const STAGING_CONFIG = {
    MY_WORKS_ENVIRONMENT: 'staging',
    MY_WORKS_DOMAIN: 'https://staging-residents-api.onlinemanagement.info',
    MY_WORKS_API_SUFFIX: '/api/v1.1',
    MY_WORKS_APP_ID: '62ecdac8e3a83561623da64b',
    APP_NAME: 'Asterix Community App (Staging)',
    BUNDLE_ID: 'info.onlinemanagement.community.staging',
    ENABLE_GPT_5_2_CODEX: true,
    ENABLE_IOS_AUTOFOCUS: false,
    APP_VERSION: '2.0.2-07.23.2026',
};

export const PROD_CONFIG = {
    MY_WORKS_ENVIRONMENT: 'production',
    MY_WORKS_DOMAIN: 'https://residents-api.onlinemanagement.info',
    MY_WORKS_API_SUFFIX: '/api/v1.1',
    MY_WORKS_APP_ID: '61af51f89695a0f376f892c1',
    APP_NAME: 'Asterix Community App',
    BUNDLE_ID: 'info.onlinemanagement.community',
    ENABLE_GPT_5_2_CODEX: true,
    ENABLE_IOS_AUTOFOCUS: false,
    APP_VERSION: '2.0.2-07.23.2026',
};

// "react-native-screens": "3.37.0",
export default function getConfig(name) {
    const environment = 'staging'; // Change this value to 'staging' or 'production' as needed
    if (environment === 'staging') {
        return STAGING_CONFIG[name] ?? '';
    } else if (environment === 'production') {
        return PROD_CONFIG[name] ?? '';
    }

    return '';
}
